import { useEffect, useState } from 'react';
import { Button, Form, Grid, Modal } from 'semantic-ui-react';
import './CreateUpdateObjectModal.scss';
import {v4 as uuidv4} from 'uuid';
import HistoryObject from '../../../../../../../../structures/historyObject';

interface CreateUpdateObjectModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    object?: HistoryObject;
    onSave: (object: HistoryObject) => void;
}

function CreateUpdateObjectModal({open, setOpen, object, onSave}:CreateUpdateObjectModalProps) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if(open) {
            if(object !== undefined){
                setName(object.name);
                setDescription(object.description);                
            }else{
                setName('');
                setDescription('');                
            }
        }
    }, [open]);

    return <Modal
        open={open}
        onClose={() => setOpen(false)}
        className='create-update-object-modal'
        size='tiny'
    >
        <Modal.Header>{object ? 'Обновить предмет' : 'Создать предмет'}</Modal.Header>
        <Modal.Content>
            <Form>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Form.Input label='Имя' placeholder='Введите имя...' value={name} onChange={(e) => setName(e.target.value)} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Form.TextArea label='Описание' placeholder='Введите описание...' value={description} onChange={(e) => setDescription(e.target.value)} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button basic onClick={() => setOpen(false)}>Отмена</Button>
            <Button primary onClick={() => {
                setOpen(false);
                onSave(new HistoryObject(object == undefined ? uuidv4() : object.id, name, description));
            }}>{object ? 'Обновить' : 'Создать'}</Button>
        </Modal.Actions>
    </Modal>
};

export default CreateUpdateObjectModal;